var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "org-detail" }, [
    _c("div", { staticClass: "detail-bg" }),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "left-con" },
        [
          _c("section-box", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.scholarsLoading,
                expression: "scholarsLoading",
              },
            ],
            staticStyle: { "margin-top": "0" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("p", { staticClass: "border-text" }, [
                      _vm._v("重点人员"),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "main",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "expert-list" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex justify-between item-center" },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: { change: _vm.handleScholarTypeChange },
                                model: {
                                  value: _vm.scholarsTypeValue,
                                  callback: function ($$v) {
                                    _vm.scholarsTypeValue = $$v
                                  },
                                  expression: "scholarsTypeValue",
                                },
                              },
                              _vm._l(_vm.scholarsTypeOption, function (item) {
                                return _c(
                                  "el-radio-button",
                                  {
                                    key: item.value,
                                    attrs: {
                                      label: item.value,
                                      disabled:
                                        _vm.orgType !== "academic" &&
                                        item.label !== "全部",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.label) + " ")]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.scholarsData.length > 0
                          ? _c("org-scholars-list", {
                              attrs: { "scholars-data": _vm.scholarsData },
                            })
                          : _c(
                              "div",
                              { staticStyle: { height: "310px" } },
                              [_c("el-empty")],
                              1
                            ),
                        _vm.scholarsData.length > 0
                          ? _c(
                              "div",
                              { staticClass: "page-container" },
                              [
                                _c("el-pagination", {
                                  attrs: {
                                    background: "",
                                    "current-page": _vm.scholarsPager.pageNum,
                                    "page-size": _vm.scholarsPager.pageSize,
                                    layout: "prev, pager, next",
                                    total: _vm.scholarsPager.total,
                                  },
                                  on: {
                                    "current-change":
                                      _vm.handleScholarsPageChange,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm.riverData.legend != null && _vm.riverData.legend.length > 0
            ? _c("section-box", {
                staticStyle: { "margin-top": "10px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "border-text" }, [
                            _vm._v("成果分析"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "main",
                      fn: function () {
                        return [
                          _vm.riverData.legend.length > 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "350px",
                                    position: "relative",
                                    width: "100%",
                                  },
                                },
                                [
                                  _c("scholar-interest-chart", {
                                    attrs: { data: _vm.riverData },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticStyle: { height: "350px" } },
                                [_c("el-empty")],
                                1
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  698096074
                ),
              })
            : _vm._e(),
          _vm.trendAnalyseYear != null && _vm.trendAnalyseYear.length > 0
            ? _c("section-box", {
                staticStyle: { "margin-top": "10px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "border-text" }, [
                            _vm._v("趋势分析"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "main",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.echartsLoading,
                                  expression: "echartsLoading",
                                },
                              ],
                            },
                            [
                              _vm.trendAnalyseYear != null &&
                              _vm.trendAnalyseYear.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "350px",
                                        position: "relative",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _c("trend-analyse-bar", {
                                        attrs: {
                                          "trend-analyse-year":
                                            _vm.trendAnalyseYear,
                                          "trend-analyse-count":
                                            _vm.trendAnalyseCount,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticStyle: { height: "350px" } },
                                    [_c("el-empty")],
                                    1
                                  ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3011395160
                ),
              })
            : _vm._e(),
          _vm.orgArea === "国内" &&
          _vm.orgType === "academic" &&
          _vm.basesData.length
            ? _c("section-box", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.basesLoading,
                    expression: "basesLoading",
                  },
                ],
                staticStyle: { "margin-top": "10px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "border-text" }, [
                            _vm._v("相关基地"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "main",
                      fn: function () {
                        return [
                          _vm.basesData.length
                            ? _c("org-bases-list", {
                                attrs: { "bases-data": _vm.basesData },
                              })
                            : _c(
                                "div",
                                { staticStyle: { height: "310px" } },
                                [_c("el-empty")],
                                1
                              ),
                          _vm.basesData.length
                            ? _c(
                                "div",
                                { staticClass: "page-container" },
                                [
                                  _c("el-pagination", {
                                    attrs: {
                                      background: "",
                                      "current-page":
                                        _vm.basesPager.pageNum + 1,
                                      "page-size": _vm.basesPager.pageSize,
                                      layout: "prev, pager, next",
                                      total: _vm.basesPager.total,
                                    },
                                    on: {
                                      "current-change":
                                        _vm.handleBasesPageChange,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  409802096
                ),
              })
            : _vm._e(),
          _c("section-box", {
            staticStyle: { "margin-top": "10px" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("p", { staticClass: "border-text" }, [
                      _vm._v("科研成果"),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "main",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.achievementLoading,
                            expression: "achievementLoading",
                          },
                        ],
                        staticClass: "achieve-list",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex justify-between item-center" },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: { change: _vm.handleAchieveTypeChange },
                                model: {
                                  value: _vm.achieveTypeValue,
                                  callback: function ($$v) {
                                    _vm.achieveTypeValue = $$v
                                  },
                                  expression: "achieveTypeValue",
                                },
                              },
                              _vm._l(_vm.achieveTypeOption, function (item) {
                                return _c(
                                  "el-radio-button",
                                  {
                                    key: item.name,
                                    attrs: { label: item.label },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.label) +
                                        " (" +
                                        _vm._s(item.count) +
                                        ") "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                            _vm.achieveTypeValue !== "奖项" &&
                            _vm.orgArea === "国内" &&
                            false
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-top": "15px" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请选择产业",
                                    },
                                    on: {
                                      change: _vm.handleAchieveChanyeChange,
                                    },
                                    model: {
                                      value: _vm.achieveChanyeValue,
                                      callback: function ($$v) {
                                        _vm.achieveChanyeValue = $$v
                                      },
                                      expression: "achieveChanyeValue",
                                    },
                                  },
                                  _vm._l(
                                    _vm.achieveChanyeOptions,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.achievementData.length === 0
                          ? _c(
                              "div",
                              { staticStyle: { height: "310px" } },
                              [_c("el-empty")],
                              1
                            )
                          : _c("achievement-list", {
                              attrs: {
                                "active-value": _vm.achieveTypeValue,
                                achievementData: _vm.achievementData,
                                "search-comp": false,
                                total: 0,
                                paperArea: _vm.orgArea,
                              },
                            }),
                      ],
                      1
                    ),
                    _vm.achievementData && _vm.achievementData.length
                      ? _c(
                          "div",
                          { staticClass: "page-container" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                background: "",
                                "current-page":
                                  _vm.achievementPager.pageNum + 1,
                                "page-size": _vm.achievementPager.pageSize,
                                layout: "prev, pager, next",
                                total: _vm.achievementPager.total,
                              },
                              on: {
                                "current-change": _vm.handleAchievePageChange,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm.orgArea === "国内" &&
          _vm.orgType === "academic" &&
          _vm.schoolListData.length
            ? _c("section-box", {
                staticStyle: { "margin-top": "10px" },
                attrs: { "show-extra": true, "extra-width": 350 },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "border-text" }, [
                            _vm._v("招生计划"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "extra",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "school-title-layout flex items-center",
                            },
                            [
                              _c("p", { staticClass: "school-year-text" }, [
                                _vm._v("年份"),
                              ]),
                              _c(
                                "el-select",
                                {
                                  attrs: { value: _vm.schoolYearValue },
                                  on: { change: _vm.schoolYearChange },
                                },
                                _vm._l(_vm.schoolYearOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                              _c("p", { staticClass: "school-city-text" }, [
                                _vm._v("所在地"),
                              ]),
                              _c("el-cascader", {
                                attrs: {
                                  placeholder: "所在地",
                                  options: _vm.city.domesticCityData,
                                  props: {
                                    expandTrigger: "hover",
                                    value: "regionName",
                                    label: "regionName",
                                  },
                                },
                                on: { change: _vm.schoolCityChange },
                                model: {
                                  value: _vm.city.myCity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.city, "myCity", $$v)
                                  },
                                  expression: "city.myCity",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "main",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.schoolListLoading,
                                  expression: "schoolListLoading",
                                },
                              ],
                            },
                            [
                              _vm.schoolListData.length
                                ? _c("org-school-list", {
                                    attrs: {
                                      "school-data": _vm.schoolListData,
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticStyle: { height: "310px" } },
                                    [_c("el-empty")],
                                    1
                                  ),
                            ],
                            1
                          ),
                          _vm.schoolListData.length
                            ? _c(
                                "div",
                                { staticClass: "page-container" },
                                [
                                  _c("el-pagination", {
                                    attrs: {
                                      background: "",
                                      "current-page":
                                        _vm.schoolYearPager.pageNum + 1,
                                      "page-size": _vm.schoolYearPager.pageSize,
                                      layout: "prev, pager, next",
                                      total: _vm.schoolYearPager.total,
                                    },
                                    on: {
                                      "current-change":
                                        _vm.handleSchoolYearPageChange,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1244150402
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "right-con" }, [
        _c(
          "div",
          { staticClass: "sticky" },
          [
            _c("org-infor", {
              attrs: {
                "info-loading": _vm.infoLoading,
                "org-detail-data": _vm.orgDetailData,
                "org-type": _vm.orgType,
              },
            }),
            _vm.hotWordData != null && _vm.hotWordData.length > 0
              ? _c("section-box", {
                  staticStyle: { "margin-top": "9px" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "border-text" }, [
                              _vm._v("核心技术"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "main",
                        fn: function () {
                          return [
                            _vm.hotWordData != null &&
                            _vm.hotWordData.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      height: "310px",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _c("scholar-hot-word", {
                                      attrs: {
                                        "hot-data": _vm.hotWordData,
                                        domId: "detail",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticStyle: { height: "310px" } },
                                  [_c("el-empty")],
                                  1
                                ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4253405695
                  ),
                })
              : _vm._e(),
            _vm.orgArea === "国内" && _vm.orgType === "company"
              ? _c(
                  "div",
                  { staticClass: "industrial-distribution" },
                  [
                    _c("section-box", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "border-text" }, [
                                  _vm._v("产业分布"),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "main",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "charts-con" },
                                  [
                                    _c("industrial-distribution", {
                                      attrs: { data: _vm.industryRadarData },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        912700215
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            false
              ? _c("section-box", {
                  staticStyle: { "margin-top": "9px" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "border-text" }, [
                              _vm._v("相关动态"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "main",
                        fn: function () {
                          return [_c("dynamic-list")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3844096562
                  ),
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }